<template>
  <div class="system-info-page">
    <Form :label-width="100">
      <div class="fielset">
        <h3>{{$t('ChangePw.ChangePw')}}</h3>
        <FormItem :label="$t('ChangePw.oldPassword')">
            <Input class="info" v-model="oldPassword"></Input>
        </FormItem>
        <FormItem :label="$t('ChangePw.newPassword')">
            <Input class="info" v-model="newPassword"></Input>
        </FormItem>
        <FormItem :label="$t('ChangePw.comfirmPassword')">
            <Input class="info" v-model="comfirmPassword"></Input>
        </FormItem>
      </div>
      <hr>
      <div class="save-btn"><Button type="primary" @click="save()">{{$t('ChangePw.save')}}</Button></div>
    </Form>
  </div>
</template>
<script>
import { Api } from '@/api'
export default {
  name: 'ChangePw',
  data () {
    return {
      oldPassword: '',
      newPassword: '',
      comfirmPassword: ''
    }
  },
  mounted () {
    this.$Message.config({
      top: 80,
      duration: 2
    })
  },
  methods: {
    save () {
      if (this.newPassword !== this.comfirmPassword) {
        this.$Message.error(this.$t('ChangePw.error'))
        return
      }
      Api.user.changePw(this.oldPassword, this.newPassword).then(res => {
        this.$Message.success(this.$t('ChangePw.success'))
      })
    }
  }
}
</script>
<style scoped>
  .system-info-page {
    padding: 10px;
    padding-left: 20px;
  }
  .fielset .info {
    width: 33.3333%;
  }
  .save-btn {
    text-align: left;
  }
  hr {
    background-color: #dbdbdb;
    border: none;
    display: block;
    height: 1px;
    margin: 1.5rem 0;
  }
</style>


// WEBPACK FOOTER //
// ChangePw.vue?f19c524c